function setVariantInTitle(data) {
  var variant = $(data).attr('title');
  var product_type = $(data).attr('data-type').replace('kork', 'C-type').replace('label', 'L-type');
  var index = $(data).attr('data-index');
  var product_available = $(data).attr('data-available');
  var data_to_type = '.home-single-product-subtitle-' + index + ' > span[data-id=type]';
  var data_to_finish = '.home-single-product-subtitle-' + index + ' > span[data-id=finish]';
  var data_to_status = '.home-single-product-status-' + index;

  $(data_to_type).html(product_type);
  $(data_to_finish).html(variant);
  $(data_to_status).html(product_available);
}

if (typeof index == 'undefined' || index <= 0) {
  var index = 1;
}

var data_from = '.color-swatch__link';
var isTypeSelectorClick = false;

$(function() {
  var indexes = $('.home-single-product-index').length;
  var this_page = $('#page_template_title').attr('value');

  function updateSelectors(index, type) {
    let base_selector = '.home-single-product-index-' + index;
    let first_swatch = base_selector + ' .color-swatch .color-swatch__item[data-type=' + type + '] .color-swatch__link';

    $(base_selector + ' .color-swatch__item').hide();
    $(base_selector + ' .product-type-' + type).show();

    var $first = $(first_swatch).first();
    if ($first.length) {
      setVariantInTitle($first);
      var variant_id = $first.attr('data-variant-id');
      if (variant_id) {
        $('#selected_variant_id').val(variant_id);
      }
      isTypeSelectorClick = true;
      $first.trigger('click');
      isTypeSelectorClick = false;
    }
  }

  $(document).on('click', '.nav--mobile .accessibleNav .grandparent > a.nav-carat, .nav--mobile .accessibleNav .parent > a.nav-carat', function(event) {
    event.preventDefault();
    $(this).closest('li').toggleClass('main-menu--expanded');
  });

  $(document).on('click', '.menuToggle', function(event) {
    event.preventDefault();
    $('.header-menu').toggleClass('main-menu--expanded');
    $('.header-search').toggleClass('main-menu--expanded');
  });

  $(document).on('click', '.product-type-selector > span', function() {
    var index = $(this).attr('data-index');
    var type = $(this).attr('data-type');
    updateSelectors(index, type);
  });

  $(document).on('click', data_from, function(e) {
    e.preventDefault();
    if (this_page == 'product') {
      if (!isTypeSelectorClick) {
        var variant_url = $(this).attr('data-url');
        if (variant_url) {
          window.location.href = variant_url;
        }
      }
    } else {
      setVariantInTitle($(this));
      var index = $(this).attr('data-index');
      var data_parent = '.product-page-' + index;
      var product_image = $(this).find('img:first').attr('src');
      var product_price = $(this).attr('data-price');
      var product_available = $(this).attr('data-available');
      var variant_url = $(this).attr('data-url');

      $(data_parent + ' .product__photo img').attr('src', product_image);
      if (product_price.length) {
        $(data_parent + ' #ProductPrice').html(product_price);
      }
      if (product_available.length) {
        $(data_parent + ' .product__status').html(product_available);
      }
      $('.home-single-product-index-' + index + ' .button-buy').attr('href', variant_url);
    }
  });

  var type_first = $('.home-single-product-index-1 .color-swatch > li:first-child').attr('data-type');
  $('.home-single-product-index-1 .color-swatch > li').each(function() {
    var product_type = $(this).attr('data-type');
    if (product_type !== type_first) {
      $('.home-single-product-index-1 .color-swatch > li[data-type=' + product_type + ']').hide();
    }
  });

  for (var i = 1; i <= indexes; i++) {
    if (this_page == 'product') {
      if ($('#selected_variant_id').length) {
        var selected_variant_id = $('#selected_variant_id').attr('value');
        var selected_product_type = $('#selected_product_type').attr('value');
        let base_selector = '.home-single-product-index-' + i;
        $(base_selector + ' .color-swatch__item').hide();
        $(base_selector + ' .product-type-' + selected_product_type).show();
      }
    } else {
      var data_from_first = '.product-page-' + i + ' .color-swatch__link-' + i + '-1';
      var type_selector = '#product-type-selector-' + i + ' > span:first-child';

      if ($(data_from_first).length) {
        $(data_from_first).trigger('click');
      }
      if ($(type_selector).length) {
        $(type_selector).trigger('click');
      }
    }
  }

});
